// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Number } from './number';
import { Shareholder } from './shareholder';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ShareHolderNumber extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  shareholderId!: number;
  numberId!: number;
  ts!: string;
  number!: Number;
  shareholder!: Shareholder;
}

